module.exports = __webpack_public_path__ + "0f2e91214b67f28fced78cd92d985ed6.woff";